import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class FocustipService {
	focustip = new EventEmitter();

	constructor() {}

	show(element, text) {
		this.focustip.emit({
			element: element,
			text: text,
		});
	}

	hide() {
		this.focustip.emit({
			element: null,
			text: null,
		});
	}
}
